import React from "react";
import Welcome from "../component/sections/Welcome";
import NotFounded from "../component/partials/other/NotFounded";
import Report from "../component/sections/report/Report";
import sitesRoutes from "../route/sites";
import publisher from "../route/publisher";
import page from "../route/page";
import position from "../route/position";
import finance from "../route/finance";

const routes = [
  {
    path: "/",
    render: () => <Welcome />,
    exact: true,
  },
  ...sitesRoutes,
  ...publisher,
  ...position,
  ...page,
  ...finance,
  {
    path: "/report",
    render: () => <Report />,
    exact: true,
  },
  {
    path: "*",
    render: () => <NotFounded />,
    exact: true,
  },
];

export default routes;
